module.exports = __webpack_public_path__ + "img/32_17.57cd2e86.png";